import {Typography} from '@mui/material';
import FlexContainer from '../../components/common/flex-container';
import NftRewardComponent from '../../components/nft-reward';
import type TokenMetadataItem from '../../components/tokens/types/token-metadata-item.ts';
import styles from '../styles.module.css';
import {styledMod} from '@/utils/styled-mod.tsx';

type NftRewardProps = {
  tokensMetadata: TokenMetadataItem[];
  tokensSymbols: string[];
};


const PageContainer = styledMod('div', styles['page-container']);

const NftReward: React.FunctionComponent<NftRewardProps> = (props: NftRewardProps) => {
  return (
    <PageContainer>
      <Typography variant="h2" className={styles['page-title']}>
        Nft reward
      </Typography>
      <FlexContainer overflowx="auto" margin="5px 0 0 0">
        <NftRewardComponent tokensMetadata={props.tokensMetadata} tokensSymbols={props.tokensSymbols}/>
      </FlexContainer>
    </PageContainer>
  );
};

export default NftReward;
